module.exports = __webpack_public_path__ + "img/metrics.fd44fec3.svg";